import React from 'react';
import './about.css';

const About = () => {
  const skills = [
    'React.js', 'Node.js', 'TypeScript', 'JavaScript',
    'HTML/CSS', 'Responsive Design', 'Git', 'RESTful APIs'
  ];

  return (
    <section id="about" className="about">
      <div className="about__inner">
        <div className="about__content">
          <h2 className="section__title">About Me</h2>
          <p className="about__text">
            I'm a passionate Full Stack Developer with a focus on creating intuitive and performant web applications. 
            With a strong foundation in both frontend and backend development, I enjoy turning complex problems into 
            simple, beautiful solutions.
          </p>
          
          <div className="skills">
            <h3 className="skills__title">Technical Skills</h3>
            <div className="skills__grid">
              {skills.map((skill) => (
                <span key={skill} className="skill__tag">{skill}</span>
              ))}
            </div>
          </div>

          <div className="about__cta">
            <a href="#contact" className="btn primary">Get in touch</a>
            <a href="/resume.pdf" className="btn outline" target="_blank" rel="noopener">
              Download Resume
            </a>
          </div>
        </div>

        <div className="about__stats">
          <div className="stat__card">
            <span className="stat__number">Fresher</span>
            <span className="stat__label">Learner</span>
          </div>
          <div className="stat__card">
            <span className="stat__number">20+</span>
            <span className="stat__label">Projects Completed</span>
          </div>
          <div className="stat__card">
            <span className="stat__number">15+</span>
            <span className="stat__label">Happy Clients</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;